module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1285.0604a839.png";